<div class="settings-title">
  {{"plan.ct.settings.additional.settings.workload.title" | translate}}

</div>
<div class="col-16 user-field section">
  <div class="row">
    <div class='col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10'>
      <label class="text-uppercase input-label">
        {{"plan.settings.ct.dlg.starting.backlog" | translate}}
      </label>
      @if(backlogForm.get('backlogInput').disabled) {
        <span tooltipStyleClass="ui-tooltip-bright"  class="info-tooltip" placement="right" ngbPopover="{{'plan.ct.settings.backlog.not.workload.msg' | translate}}" popoverClass="popover-tooltip" container="body"  triggers="mouseenter:mouseleave:click" [openDelay]="300">
          <i class="icon-info"></i>
        </span>
      }
    </div>
  </div>
  <div class="row">
    <div class='col-sm-12'>
      <div>
        <form [formGroup]="backlogForm">
          @if(backlogForm.get('backlogInput').enabled){
          <p-inputnumber
            mode="decimal"
            [useGrouping]="false"
            name="startingBacklogInput"
            inputId="startingBacklogInput"
            id="startingBacklogInput"
            autocomplete="off"
            formControlName="backlogInput"
            styleClass="backlog-input"
            [required]="true"
            [min]="0"
            (onInput)="onBacklogInput($event)">
          </p-inputnumber> <span class="side-info">{{"plan.settings.ct.dlg.contacts" | translate}}</span>
          } @else{
            <input pInputText class="p-inputnumber-input p-inputnumber backlog-input-disabled" disabled>
            <span class="side-info">{{"plan.settings.ct.dlg.contacts" | translate}}</span>
          }
          <div *ngIf="invalidBacklogInput" class="error-message">{{'plan.settings.ct.dlg.contacts.validation'|translate}}</div>
        </form>
      </div>
    </div>
  </div>
</div>
<div class="settings-title">
  {{"plan.ct.settings.additional.settings.projected.performance.title" | translate}}
</div>
<div class="col-16 user-field section">
  <div class="row">
    <div class='col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10'>
      <label class="text-uppercase input-label">
        {{"plan.ct.settings.projected.asa.threshold" | translate}}
      </label>
    </div>
  </div>
  <div class="row">
    <div class='col-sm-12'>
      <div>
        <form [formGroup]="reverseSolveForm">
          <input [size]="14" [required]="false" class="p-inputtext p-component p-element p-inputnumber-input p-inputnumber"
                 [type]="projectedAsaInputType" formControlName="projectedAsa" [min]="0" (input)="onAsaThresholdInput($event)"
                 data-testid="asaThresholdInput">
          <span class="side-info">
            @if(this.projectedAsa==='--'){
              <span> {{"plan.ct.settings.multiple.values"|translate}}</span>
            }@else{
              <span> {{"plan.ct.settings.misc.seconds" | translate}}</span>
            }
          </span>
          <div *ngIf="invalidProjectedAsa" class="error-message">{{'plan.ct.settings.misc.projectedAsa.validation'|translate}}</div>
        </form>
      </div>
    </div>
  </div>
</div>
